import { apiClient } from './client';

export interface SessionInfo {
  authenticated: boolean;
  expiresAt?: number; // ms epoch
  now: number;        // server clock, ms epoch (for skew correction)
  version?: string;   // server app version; only present when authenticated
}

export const sessionApi = {
  info: async (): Promise<SessionInfo> => {
    const { data } = await apiClient.get<SessionInfo>('/auth/session-info');
    return data;
  },
};
